import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const McNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="mc" />;
};
